import React from "react";
import T from "prop-types";

import FileChooser2g from "2g-file-chooser";

import Prilohy from "./Prilohy";
import useFileChooser from "./hooks/useFileChooser";

function FileChooser({ path, hasDelete, hasDownload }) {
  const { value, onChange, onDelete, onDownload } = useFileChooser({
    path,
    hasDelete,
    hasDownload
  });

  return (
    <div className="b2b-FileChooser">
      <FileChooser2g value={value} onChange={onChange} multiple />
      <Prilohy files={value} onDownload={onDownload} onDelete={onDelete} />
    </div>
  );
}

FileChooser.propTypes = {
  path: T.string,
  hasDelete: T.bool,
  hasDownload: T.bool
};

export default React.memo(FileChooser);
